import type React from 'react';
import type { APIError, Conversation, Message, Assistant } from '../../api/types';
import { ChatContext } from './ChatContext';
import { ChatHeader } from '../core/ChatHeader';
import { ChatFooter } from '../core/ChatFooter';
import { ChatNavigation } from '../core/ChatNavigation';
// import { MessageList } from '../core/MessageList';
import { MemoizedMessageList } from '../core/MessageList';
// import { StreamingMessage } from '../core/StreamingMessage';
import { MemoizedStreamingMessage } from '../core/StreamingMessage';
import { MessageInput } from '../core/MessageInput';
import { AssistantListPanel } from '../panels/AssistantListPanel';
import { ChatHistoryPanel } from '../panels/ChatHistoryPanel';
import { QuickPromptsPanel } from '../panels/QuickPromptsPanel';
import { TypingIndicator } from '../shared/TypingIndicator';
import styles from './Chat.module.css';
import type { ChatVariant } from './types';

export interface ChatProps {
  children: React.ReactNode;
  conversationId?: string;
  variant?: ChatVariant;
  className?: string;
  
  messages?: Message[];
  streamingMessage?: string;
  isSending?: boolean;
  isLoading?: boolean;
  error?: APIError | null;
  conversations?: Conversation[];
  currentConversation?: Conversation | null;
  assistants?: Assistant[];
  currentAssistantId?: string;
}

export function Chat({
  children,
  conversationId,
  variant = 'full',
  className = '',
  
  messages = [],
  streamingMessage = '',
  isSending = false,
  isLoading = false,
  error,
  conversations = [],
  currentConversation,
  assistants = [],
  currentAssistantId,
}: ChatProps) {
  const contextValue = {
    conversationId,
    messages,
    streamingMessage,
    isSending,
    isLoading,
    error,
    conversations,
    currentConversation,
    assistants,
    currentAssistantId,
    variant,
  };

  return (
    <ChatContext.Provider value={contextValue}>
      <div className={`${styles.chat} ${styles[variant]} ${className}`}>
        {/* {currentAssistantId && (
          <div className={styles.currentAssistant}>
            Current Assistant: {currentAssistantId}
          </div>
        )} */}
        {children}
      </div>
    </ChatContext.Provider>
  );
}

Chat.Header = ChatHeader;
Chat.Footer = ChatFooter;
Chat.Navigation = ChatNavigation;
Chat.Messages = MemoizedMessageList;
Chat.StreamingMessage = MemoizedStreamingMessage;
Chat.TypingIndicator = TypingIndicator;
Chat.Input = MessageInput;
Chat.Panel = {
  Assistants: AssistantListPanel,
  History: ChatHistoryPanel,
  Prompts: QuickPromptsPanel,
};
